export const DataGateWayUrls = {
	FETCH_COMPONENT: `${process.env.REACT_APP_DATA_GATEWAY}/v3/search`,
	FETCH_ORDER_LAYOUT: `${process.env.REACT_APP_DATA_GATEWAY}/api/v1/order/layout`,
	FETCH_ORDER_DATA: `${process.env.REACT_APP_DATA_GATEWAY}/api/v1/order/OrderListingData`,
	FETCH_DETAIL_LAYOUT: `${process.env.REACT_APP_DATA_GATEWAY}/api/v1/order/orderDetailLayout`,
	FETCH_DETAIL_DATA: `${process.env.REACT_APP_DATA_GATEWAY}/api/v1/order/orderDetailData`,
};
